
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";



import * as React from "react";
import {GroupProperties} from "InternalShared/PageBuilder/Controls/Properties/styles/GroupProperties";
import {PDFControlBase} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase";
import {DimensionStyleSet} from "InternalShared/PageBuilder/Controls/Properties/StyleSets/DimensionStyleSet";
import {NumberProperty} from "InternalShared/PageBuilder/Controls/Properties/NumberProperty";
import {ColorProperty} from "InternalShared/PageBuilder/Controls/Properties/ColorProperty";
import {ButtonProperties} from "InternalShared/PageBuilder/Controls/Properties/ButtonProperties";
import {FieldsProperty} from "InternalShared/PageBuilder/Controls/Properties/FieldsProperty";
import {AllowedResizeDirection} from "InternalShared/Dto";
import {ImageProperty} from "InternalShared/PageBuilder/Controls/Properties/ImageProperty";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {TextControlOptions} from "PageBuilder/pagebuilder/Controls/ControlsList/TextControl.Options";
import {QRControlOptions} from "./QRControl.Options";
import {CancellationToken, WpAjaxPost} from "shared/utilities/ajax/WPAjaxPost";
import {TextProperty} from "InternalShared/PageBuilder/Controls/Properties/TextProperty";
import {PropertyBase} from "InternalShared/PageBuilder/Controls/Properties/PropertyBase";
import {SimpleTextProperty} from "InternalShared/PageBuilder/Controls/Properties/SimpleTextProperty";
import {DropDownProperty} from "InternalShared/PageBuilder/Controls/Properties/DropDownProperty";

declare let rednaoPDFInvoiceParams:any;
export class QRControl extends PDFControlBase{
    private token:CancellationToken;
    private properties:GroupProperties[];
    private timeout:any=null;
    public AllowedResizeDirection:AllowedResizeDirection="none";
    GetInitialOptions(): Promise<PDFControlBaseOptions> {
        return new Promise(resolve => {
            resolve(new QRControlOptions().Merge());
        });
    }

    GetProperties(): GroupProperties[] {
        if(this.properties==null)
        {
            this.properties=[new GroupProperties('General')
                .AddProperties([
                    new SimpleTextProperty(this,'Text').Focus(),
                    new DropDownProperty(this,"Size")
                        .AddOption('Small','2')
                        .AddOption('Normal','3')
                        .AddOption('Big','4')
                        .AddOption('Very Big','5')
                ])];
        }

        return this.properties;
    }

    GetStyles(): GroupProperties[] {
        return [];
    }

    protected async InternalGenerateHtml($container: JQuery<HTMLElement>) {
        $container.empty().append('<span class="fa-spin fa fa-spinner"></span>');
        if(this.token!=null)
            this.token.Cancel();
        if(this.timeout!=null)
            clearTimeout(this.timeout);
        this.timeout=setTimeout(async ()=>{
            let result:any=(await WpAjaxPost.CancellablePost('qrcode_preview',{options:this.Options.ToObject()}, this.token=new CancellationToken));
            if(result==null||result.wasCancelled)
                return;

            $container.empty().append(result.result);

        },1000)


    }

    protected InternalGetLabel() {
        return 'QRCode';
    }


}
